import { createAction } from 'redux-actions'

import { TOGGLE_TAB } from './types'

export const toggleTab = createAction(TOGGLE_TAB)
